import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesLogTypesDetailComponent } from './cases-log-types-detail/cases-log-types-detail.component';
import { CasesLogTypesListComponent } from './cases-log-types-list/cases-log-types-list.component';

const routes: Routes = [
    {
        path: 'casesLogTypes',
        children: [
            { path: '', component: CasesLogTypesListComponent }
        ]
    },
    {
        path: 'casesLogTypes/:id',
        children: [
            { path: '', component: CasesLogTypesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CasesLogTypesRoutingModule { }
